import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useUnit } from 'effector-react';
import { $portalSettings } from '@nx-frontend/shared/store/portal';
import { $isCustomizerMode, $sectionRoot } from '@nx-frontend/shared/store/portal-app';
import { ControlbarEditEntityType, ControlbarEditParams } from '@nx-frontend/shared/types';

export interface NavigateControlbarPayload {
  entityType: ControlbarEditEntityType | null;
  entityId?: string;
}

export const useNavigateControlbar = () => {
  const [isCustomizer, portalSettings, sectionRoot] = useUnit([$isCustomizerMode, $portalSettings, $sectionRoot]);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  return ({ entityType, entityId }: NavigateControlbarPayload) => {
    const currentParams = new URLSearchParams(searchParams);
    if (entityType) {
      currentParams.set(ControlbarEditParams.ENTITY_TYPE, entityType);
    } else {
      currentParams.delete(ControlbarEditParams.ENTITY_TYPE);
    }

    if (entityId) {
      currentParams.set(ControlbarEditParams.ENTITY_ID, entityId);
    } else {
      currentParams.delete(ControlbarEditParams.ENTITY_ID);
    }

    const preparedParams = currentParams.toString()?.length ? `?${currentParams.toString()}` : '';
    if (isCustomizer && sectionRoot.includes('/visual')) {
      window.history.pushState({}, '', `${pathname}${preparedParams}`);
    } else {
      router.push(`/portal/${portalSettings.id}/visual${preparedParams}`);
    }
  };
};
